import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const ThemeToggle = () => {
  const { resolved, setTheme } = useTheme();
  const isDark = resolved === 'dark';

  const toggle = () => {
    const newTheme = isDark ? 'light' : 'dark';
    setTheme(newTheme);
    axios.put(`${API_URL}/users/me/theme`, { theme: newTheme }).catch(() => {});
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      className="p-2 rounded-lg hover:bg-[var(--crm-bg-btn-secondary)] text-[var(--crm-text-secondary)] hover:text-[var(--crm-text-primary)] transition-colors"
      title={isDark ? 'Przełącz na jasny' : 'Przełącz na ciemny'}
    >
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
};
